module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/logo_teams.2da5b2c1a6861ba76de6c658322f4626.svg";